// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__yWrYc","menu__item--current":"menu_menu__item--current__quEsF"};